import React from 'react'
import Link from 'gatsby-link'
import MenuComponent from '../../components/burger-menu';
import LogoComponent from '../../components/logo';
import HeaderNav from '../../components/header-nav';
import 'react-sticky-header/styles.css';
import StickyHeader from 'react-sticky-header';
import Scrollchor from 'react-scrollchor';


const SmallHeader = () =>
<div className="header--sticky">
  <div>
    <Scrollchor to="#home" className="header-logo">
      <LogoComponent class="logo--sm"></LogoComponent>
    </Scrollchor>
  <HeaderNav class="header-nav" />
  </div>
</div>

const Header = () =>
  <div className="header--basic" id="home">
    {/* <Link to="/" className="header-logo">
      <LogoComponent class="logo--l"></LogoComponent>
    </Link>
    <h2 className="header-title">
      7th PZAF / PALERMO
          <span className="header-subtitle">28th - 30th June 2018</span>
    </h2> */}
    <HeaderNav class="header-nav" />
  </div>

  const HomeHeader = () =>
  <StickyHeader
  // This is the sticky part of the header.
  header={
    <SmallHeader />
  }
>
  <section style={{ zIndex: '50' }}>
    <Header />
  </section>
</StickyHeader>

export default HomeHeader



// WEBPACK FOOTER //
// ./src/components/headers/home-header.js